import { render, staticRenderFns } from "./expireRemindRegionPage.vue?vue&type=template&id=572c5dd8&scoped=true&"
import script from "./expireRemindRegionPage.vue?vue&type=script&lang=js&"
export * from "./expireRemindRegionPage.vue?vue&type=script&lang=js&"
import style0 from "./expireRemindRegionPage.vue?vue&type=style&index=0&id=572c5dd8&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "572c5dd8",
  null
  
)

export default component.exports